import { createDomain, sample } from 'effector'
import { FormValues } from '~/entities/MassMailing/ui/Form/model'
import { AxiosErrorType, MassMailing } from '~/shared/api'
import { pushFx } from '~/shared/lib/history'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { isString } from '~/shared/lib/utils'

export const domain = createDomain('features.massMailings.addMassMailing')

export const $defaultValues = domain.createStore<Partial<FormValues>>({
  isActive: true,
})

export const createFx = domain.createEffect<
  FormValues,
  MassMailing,
  AxiosErrorType
>({
  async handler(attrs) {
    const { regionsIds, userStatuses, scheduledAt, ...restAttrs } = attrs
    const formattedAttrs = {
      ...restAttrs,
      userStatuses: (userStatuses || []).map((status) =>
        isString(status) ? status : status.id,
      ),
      scheduledAt: scheduledAt || undefined,
    }

    const massMailing = new MassMailing(formattedAttrs)

    if (Array.isArray(regionsIds)) massMailing.setRegions(regionsIds)

    const result = await massMailing.save()
    return result.getModel() as MassMailing
  },
})

sample({
  clock: createFx.doneData,
  fn() {
    return {
      message: 'Рассылка создана',
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: createFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: createFx.doneData,
  fn(massMailing) {
    return `/mass-mailing/${massMailing.getApiId()}`
  },
  target: pushFx,
})

export const formSubmitted = domain.createEvent<FormValues>()
sample({
  clock: formSubmitted,
  target: createFx,
})
